import React from "react";
import { observer } from "mobx-react";
import { SimulationSessionViewStore } from "../../store";
import { SimulationSessionViewForm } from "./SimulationSessionViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SimulationSessionViewProps = {
  simulationSessionViewStore: SimulationSessionViewStore;
};

export const SimulationSessionView: React.FC<SimulationSessionViewProps> =
  observer(({ simulationSessionViewStore }) => {
    return (
      <div>
        <SimulationSessionViewForm
          status={simulationSessionViewStore.statusValue}
          mode={simulationSessionViewStore.modeValue}
          label={simulationSessionViewStore.labelValue}
          entryPipeline={simulationSessionViewStore.entryPipelineValue}
          scenario={simulationSessionViewStore.scenarioValue}
          resolvedGates={simulationSessionViewStore.resolvedGatesValue}
          currentGate={simulationSessionViewStore.currentGateValue}
          correlationId={simulationSessionViewStore.correlationIdValue}
          relatedEntityType={simulationSessionViewStore.relatedEntityTypeValue}
          relatedEntityId={simulationSessionViewStore.relatedEntityIdValue}
          startedAt={simulationSessionViewStore.startedAtValue}
          completedAt={simulationSessionViewStore.completedAtValue}
          triggeredByValue={simulationSessionViewStore.triggeredByValue}
          onPrint={(handlePrint: () => void) =>
            simulationSessionViewStore.printSimulationSession(handlePrint)
          }
          onCancel={() => simulationSessionViewStore.cancelSimulationSession()}
          onEdit={
            simulationSessionViewStore.isEditEnabled
              ? () => simulationSessionViewStore.editSimulationSession()
              : undefined
          }
        />
        <ErrorDialog
          open={simulationSessionViewStore.errorDialogOpened}
          title={simulationSessionViewStore.errorTitle}
          description={simulationSessionViewStore.errorDescription}
          onClose={() => simulationSessionViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
